import { spaceBoxHeight, spaceBoxWidth } from "./spaceVars";

export function wpxToPcnt(pix) {
  return Math.round((pix / spaceBoxWidth) * 1000);
}
export function hpxToPcnt(pix) {
  return Math.round((pix / spaceBoxHeight) * 1000);
}
export function xPcntToPx(pcnt) {
  return (pcnt / 1000) * spaceBoxWidth;
}
export function yPcntToPx(pcnt) {
  return (pcnt / 1000) * spaceBoxHeight;
}
